import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import pathName from './pathName.constant'
import { getUserProfileApi } from '../components/userManagement/user.api'
import useRedux from '../hooks/useRedux'
import useRouter from '../hooks/useRouter'
import { profileDetails } from '../redux/user_management/action'
import { getItem } from '../utils/localstorage'

const ProtectedRoute = ({ children }) => {
  const isAuth = getItem('token')
  const { queryParams } = useRouter()
  const code = queryParams.get('code')
  let navigatePath = pathName.LOGIN
  const userData = JSON.parse(getItem('userData'))
  const { dispatch } = useRedux()
  const jobId = queryParams.get('jobId')
  const status = queryParams.get('status')
  const jobType = queryParams.get('jobType')

  useEffect(() => {
    const getProfile = async () => {
      const response = await getUserProfileApi({
        id: userData?.id,
      })
      if (response?.data?.data) {
        dispatch(profileDetails(response?.data?.data))
      }
    }
    if (isAuth) getProfile()
  }, [])

  if (code) navigatePath += `?code=${code}`

  return isAuth ? (
    children
  ) : (
    <Navigate
      to={navigatePath}
      replace={true}
      state={{ params: { jobId, status, jobType } }}
    />
  )
}

export default ProtectedRoute
